<template>
  <div v-if="paymentDetails&&paymentStatus" class="thankyou_page" id="flight-result-wrapper">
    <div class="tq-wrapper">
      <section class="main">
        <div class="row">
          <div class="col-md-6 action-img">
            <img
              v-if="paymentStatus=='SUCCESSPAGE'"
              src="@imgPath/img/svg/img/succes-img.svg"
              alt
            />
            <img v-if="paymentStatus=='ERRORPAGE'" src="@imgPath/img/svg/img/failed.svg" alt />
            <img v-if="paymentStatus=='PENDINGPAGE'" src="@imgPath/img/svg/img/pending.svg" alt />
          </div>

          <div
            :class="paymentStatus=='SUCCESSPAGE'?'col-md-6 book-details success':
                    paymentStatus=='ERRORPAGE'?'col-md-6 book-details failed':
                
                    'col-md-6 book-details pending'"
          >
            <div class="title-main">
              <span></span>
              <span>
                {{paymentStatus=='SUCCESSPAGE'?$t("cPaymentStatus.paymentSuccessful"):paymentStatus=='ERRORPAGE'?
                $t("cPaymentStatus.paymentFailed"):$t("cPaymentStatus.paymentPending")}}
              </span>


            </div>
            <div v-if="paymentDetails.orderID" class="row">
              <div class="col-md-6">
                <div class="content-section">
<!--                  <span>{{$t("cPaymentStatus.bookResId")}}</span>-->
                  <span>{{$t("cPaymentStatus.transactionId")}}</span>
                  <span>{{ paymentDetails.orderID}}</span>
                </div>
              </div>
            </div>
            <div class='row'>
            <div v-if="paymentStatus=='SUCCESSPAGE'" class="cta-seaction col-md-4">
                            <button @click="navigateToViewStatement()" class="general-btn success">
                                View Statement
                            </button>
            </div>
            <div v-if="paymentStatus=='ERRORPAGE'||'PENDINGPAGE'" class="cta-seaction col-md-4">
                            <button @click="navigateToPayment()" class="general-btn success">
                                {{GET_POST_PAID_PAY_RES?'Back to Payment':'Back to Topup'}}
                            </button>
            </div>
             </div>
        
          </div>
        </div>
      </section>
      <section v-if="paymentDetails.priceDetails" class="bk-details">
        <div class="sec-title"> {{$t("cPaymentStatus.payDet")}} </div>
        <div class="content justify-center">
          <div class="payment-details">
            <div class="block">
              <div class="nor">{{$t("cPaymentStatus.payDet")}}</div>
              <div v-if="paymentDetails.priceDetails.paymentMethodLogoURL" class="py-mth-logo">
                <img
                  :src="paymentDetails.priceDetails.paymentMethodLogoURL"
                  :onerror="defaultALImg"
                />
              </div>
            </div>
            <div class="block">
              <div class="title">{{$t("cPaymentStatus.totCharge")}}</div>
              <div
                class="price"
              >{{paymentDetails.priceDetails.currency +' '}} {{paymentDetails.priceDetails.total.toString() | formatNumber(paymentDetails.priceDetails.currency)}}</div>
            </div>
            <div class="block">
              <div class="title">{{$t("cPaymentStatus.fareBreak")}}</div>
              <div class="total">
                <table>
                  <tbody>
                    <tr>
                      <!-- <td>{{$t("cPaymentStatus.baseFare")}}</td> -->
                      <td>{{$t("cPaymentStatus.paymentAmt")}}</td>
                      <td>{{paymentDetails.priceDetails.currency }}</td>
                      <td>{{paymentDetails.priceDetails.baseFare.toString() | formatNumber(paymentDetails.priceDetails.currency)}}</td>
                    </tr>
                    <!-- <tr>
                      <td>{{$t("cPaymentStatus.tax")}}</td>
                      <td>{{paymentDetails.priceDetails.currency}}</td>

                      <td>{{paymentDetails.priceDetails.tax.toString() | formatNumber(paymentDetails.priceDetails.currency)}}</td>
                    </tr> -->
                    <tr v-if="paymentDetails.priceDetails.fee!=0">
                      <td>{{$t("cPaymentStatus.fees")}}</td>
                      <td>{{paymentDetails.priceDetails.currency }}</td>
                      <td>{{paymentDetails.priceDetails.fee.toString() | formatNumber(paymentDetails.priceDetails.currency)}}</td>
                    </tr>
                    <tr>
                      <td>{{$t("cPaymentStatus.total")}}</td>
                      <td>{{paymentDetails.priceDetails.currency}}</td>
                      <td>{{paymentDetails.priceDetails.total.toString() | formatNumber(paymentDetails.priceDetails.currency)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
import { COMPONENT_NAME, PATHNAME, ROUTER_PARAM, PAYMENT_PROCEED_TO } from "../../util/constants";
import router, { navigate, goBack } from "../../router/index";
import Logger from "../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import BaseConfiguration from "../../config/base";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody
} from "../../util/util";

export default {
  name: COMPONENT_NAME.C_PAYMENT_STATUS,
  props: {
    paymentStatus: {
      type: String
    }
  },
  data() {
    return {
      defaultALImg: BaseConfiguration.defaultALImg,
      paymentDetails: null,
      
    };
  },
  computed: {
    ...mapGetters("sPaymentStatus", {
      GET_RECHARGE_DET_RES: "GET_RECHARGE_DET_RES"
    }),
     ...mapGetters("sPrepaidTopUp", {
      GET_PRE_PAID_PAY_RES: "GET_PRE_PAID_PAY_RES"
    }),

    ...mapGetters("sPostPaidTopUp", {
      GET_POST_PAID_PAY_RES: "GET_POST_PAID_PAY_RES"
    })
  },

  methods: {
    navigateToPayment() {
        try {
          if(BaseConfiguration.isDebug) console.log("navigateToPayment");
          // navigate(PATHNAME.AGENT_VIEW_STATEMENTS)
         if (this.GET_POST_PAID_PAY_RES) {
                navigate(PATHNAME.AGENT_DEPOSIT);
              } else if (this.GET_PRE_PAID_PAY_RES) {
                navigate(PATHNAME.TOPUP);
              }
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_PAYMENT_STATUS,
                  "error in navigateToPayment",
                  err.toString(),
                  "navigateToPayment",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
   },

    navigateToViewStatement() {
        try {
          if(BaseConfiguration.isDebug) console.log("navigateToViewStatement");
          // navigate(PATHNAME.AGENT_VIEW_STATEMENTS)
         if (this.GET_POST_PAID_PAY_RES) {
                navigate(PATHNAME.AGENT_VIEW_STATEMENTS);
              } else if (this.GET_PRE_PAID_PAY_RES) {
                navigate(PATHNAME.TOPUP_REPORT);
              }
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_PAYMENT_STATUS,
                  "error in navigateToViewStatement",
                  err.toString(),
                  "navigateToViewStatement",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
   }, 
  },
  created() {
    try {
       this.$root.$emit("toggle-sidebar-minimize");
      if (this.GET_RECHARGE_DET_RES && this.GET_RECHARGE_DET_RES.data) {
        if(this.paymentStatus==this.GET_RECHARGE_DET_RES.data.proceedTo){
        this.paymentDetails = this.GET_RECHARGE_DET_RES.data;
        }else{
           this.paymentDetails = null;
        }
      
      } else {
        throw "invalid payment details";
      }
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.C_PAYMENT_STATUS,
        'error while created a payment status component for '+this.paymentStatus+' page',
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  }
};
</script>